
export default {

    notAccessibleMsg() {
        toastr.error(i18n.permission.permission_denied);
    },

    featureNotAvailableMsg() {
        toastr.error(i18n.general.feature_not_available);
    },

    getUserStatus(user) {
        let status = [];
        if (user.status === 'activated')
            status.push({ 'color': 'success', 'label': i18n.user.status_activated });
        else if (user.status === 'pending_activation')
            status.push({ 'color': 'warning', 'label': i18n.user.status_pending_activation });
        else if (user.status === 'pending_approval')
            status.push({ 'color': 'warning', 'label': i18n.user.status_pending_approval });
        else if (user.status === 'banned')
            status.push({ 'color': 'danger', 'label': i18n.user.status_banned });
        else if (user.status === 'disapproved')
            status.push({ 'color': 'danger', 'label': i18n.user.status_disapproved });

        return status;
    },

    formAssign(form, data) {
        for (let key of Object.keys(form)) {
            if (key !== "originalData" && key !== "errors" && key !== "autoReset" && key !== "providers") {
                form[key] = data[key] || '';
            }
        }

        return form;
    },

    toWord(value) {
        if (!value) return;

        value = value.replace(/-/g, ' ');
        value = value.replace(/_/g, ' ');

        return value.toLowerCase().replace(/\b[a-z]/g, function (value) {
            return value.toUpperCase();
        });
    },

    showDataErrorMsg(error) {
        this.setLastActivity();
        if (error.hasOwnProperty("error")) {
            toastr.error(i18n.general[error.error]);
            if (error.error === 'token_expired') {
                router.push('/login');
            }
        } else if (error.hasOwnProperty("response") && error.response.status === 403) {
            toastr.error(i18n.general.permission_denied);
        } else if (error.hasOwnProperty("response") && error.response.status === 500) {
            toastr.error('500 Internal Server Error');
        } else if (error.response && error.response.data.errors.hasOwnProperty("message")) {
            toastr.error(error.response.data.errors.message[0]);
        } else if (error) {
            console.log(error);
        }
    },

    fetchDataErrorMsg(error) {
        return error.response.data.errors.message[0];
    },

    showErrorMsg(error) {
        this.setLastActivity();
        if (error.hasOwnProperty("error")) {
            toastr.error(i18n.general[error.error]);
            if (error.error === 'token_expired') {
                router.push('/login');
            }
        } else if (error.hasOwnProperty("response") && error.response.status === 403) {
            toastr.error(i18n.general.permission_denied);
        } else if (error.hasOwnProperty("response") && error.response.status === 500) {
            toastr.error('500 Internal Server Error');
        } else if (error.errors.hasOwnProperty("message"))
            toastr.error(error.errors.message[0]);
    },

    limitWords(textToLimit, wordLimit) {
        if (!textToLimit) return;
        let finalText = "";
        let text2 = textToLimit.replace(/\s+/g, ' ');
        let text3 = text2.split(' ');
        let numberOfWords = text3.length;
        let i = 0;

        if (numberOfWords > wordLimit) {
            for (i = 0; i < wordLimit; i++) {
                finalText = finalText + " " + text3[i] + " ";
            }

            return finalText + "...";
        }

        return textToLimit;
    },

    showSpinner() {
        document.getElementsByClassName("preloader")[0].style.display = "block";
    },

    hideSpinner() {
        document.getElementsByClassName("preloader")[0].style.display = "none";
    },
    dateToString(date) {
        return `${date.getFullYear()}-${('00' + (date.getMonth() + 1)).slice(-2)}-${('00' + date.getDate()).slice(-2)}`;
    },

    matchInputSelect(value) {
        if(value === null) return null;
        return value.match(/.+?(?=-)/)[0].trim();
    },
    configQuery(queryParams) {
        let query = '?';
        Object.keys(queryParams).map((key) => {
            if (queryParams[key]) {
                query += `${key}=${encodeURIComponent(queryParams[key])}&`;
            }
        });
        return query;
    }
}
